cancelWorkersWhen